module.exports = __webpack_public_path__ + "russierenouvelables/img/team-market.38eaa7de.webp";